module.exports = __webpack_public_path__ + "img/com.electrolux.connectapp.arcon.d546c7af.webp";